
import { Component, OnInit } from '@angular/core';
import { PermissionService } from './@core/permission/permission.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss' ]
})
export class AppComponent implements OnInit {

   constructor(private permissionService: PermissionService) {}

  ngOnInit(): void {

    const savedPermissions = localStorage.getItem('permissions');

    if (savedPermissions) {
      this.permissionService.setPermissions(JSON.parse(savedPermissions));
    }

  }
}
